module.exports = __webpack_public_path__ + "static/img/yingheqrcode.f8bde21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yingheqrcode.jpg
// module id = BbcO
// module chunks = 1